import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Chip from '@material-ui/core/Chip'
import { makeStyles } from '@material-ui/core/styles'
import RepeatIcon from 'components/material-symbol/icons/Repeat'

const useStyles = makeStyles({
  root: {
    height: 24,
    borderRadius: 8,
    backgroundColor: '#E0EAFF',
    color: '#001C57',
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.02em',
    '& .MuiChip-icon': {
      color: 'inherit',
      fontSize: 16,
      width: 16,
      height: 16,
      marginLeft: 6,
    },
  },
})

const RecurringChip = ({ className }) => {
  const classes = useStyles()

  return (
    <Chip
      size="small"
      icon={<RepeatIcon />}
      label="Recurring"
      className={clsx(classes.root, className)}
      data-testid="recurring-chip"
    />
  )
}

RecurringChip.propTypes = {
  className: PropTypes.string,
}

export default RecurringChip
